import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  Label,
} from "reactstrap";
import ReactDatePicker from "react-datepicker";
import { CalenderIcon } from "../../../components/Icon";
import moment from "moment";
import Select from "react-select";
import { components } from "react-select";
import { CircularAvatar } from "../../../components/commons";
import { useEffect, useState } from "react";
import useDebounce from "../../../customHooks/useDebounce";
import { CountryListTypes } from "../../../redux/masterData/masterTypes";
import { GetCountryListDataPayloadType } from "../../../commonTypes/masterDataTypes";
import { DropDownUserType } from "../../Jobs/RecurringJobReport";
import { returnInputFieldLength } from "../../../utils/commonFunctions";

export type DropDownType = {
  value: string | null | number;
  label: string;
};

type AppProps = {
  isEdit: boolean;
  date: string;
  token: null | string;
  offset: number;
  countryList: CountryListTypes[] | [];
  description: string;
  countryFetching: boolean;
  countryListTotalCount: number;
  dispatchGetCountryListAction: (data: GetCountryListDataPayloadType) => void;
  countryListDropdownSelected: DropDownType;
  setCountryListDropDownSelected: React.Dispatch<
    React.SetStateAction<DropDownType>
  >;
  showAddEditHolidayCalenderModal: boolean;
  handleAddHoliday: () => void;
  handleDescriptionChange: (data: any) => void;
  handleDateChange: (data: string) => void;
  toggleAddEditHolidayCalenderModal: () => void;
  finalBranchDataList: any;
  branch: DropDownUserType[];
  handleBranchDropDownChange: (data: any) => void;
  branchFetching: boolean;
  setBranchText: React.Dispatch<React.SetStateAction<string>>;
  setBranchoffset: React.Dispatch<React.SetStateAction<number>>;
  subDescription: string;
  handleSubDescriptionChange: (data: any) => void;
};

const AddEditHolidayCalender = ({
  showAddEditHolidayCalenderModal,
  toggleAddEditHolidayCalenderModal,
  isEdit,
  date,
  handleDateChange,
  token,
  offset,
  handleAddHoliday,
  description,
  handleDescriptionChange,
  countryListTotalCount,
  dispatchGetCountryListAction,
  countryList,
  countryFetching,
  countryListDropdownSelected,
  setCountryListDropDownSelected,
  finalBranchDataList,
  branch,
  handleBranchDropDownChange,
  branchFetching,
  setBranchText,
  setBranchoffset,
  subDescription,
  handleSubDescriptionChange,
}: AppProps) => {
  const [loadCondition, setLoadCondition] = useState(true);
  const [finalCountryDropDownList, setFinalCountryDropdownList] = useState<
    any[] | []
  >([]);
  const [clearSearchText, setClearSearchText] = useState(false);
  const [text, setText] = useState("");
  const [internalOffset, setInternalOffset] = useState(0);
  const [limit, setLimit] = useState(20);

  useEffect(() => {
    if (token) {
      let finalCountryData = {
        token,
        offset: internalOffset,
        limit,
        search_term: text,
      };
      if (offset <= +countryListTotalCount) {
        dispatchGetCountryListAction(finalCountryData);
      }
    }
  }, [internalOffset]);

  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setBranchoffset((prv: any) => prv + limit);
  };

  useEffect(() => {
    const countryData = countryList?.map((data: any) => {
      return {
        value: data?.name,
        label: data?.name,
      };
    });
    if (internalOffset > 0) {
      setFinalCountryDropdownList([
        ...finalCountryDropDownList,
        ...countryData,
      ]);
    } else {
      setFinalCountryDropdownList(countryData);
    }
  }, [countryList]);

  const handleChangeCountry = (data: any) => {
    setCountryListDropDownSelected({
      value: data?.value,
      label: data?.label,
    });
  };

  const fetchInternalNewData = (search: string) => {
    setClearSearchText(true);
    const finalData = {
      token,
      offset: internalOffset,
      limit,
      search_term: text,
    };
    if (internalOffset === 0) {
      dispatchGetCountryListAction(finalData);
    } else {
      setInternalOffset(0);
    }
  };
  useEffect(() => {
    if (clearSearchText) {
      const finalData = {
        token,
        offset: internalOffset,
        limit,
        search_term: text,
      };
      if (text?.length === 0) {
        dispatchGetCountryListAction(finalData);
        setInternalOffset(0);
      }
    }
  }, [clearSearchText, text]);

  useDebounce(
    () => {
      if (text) {
        fetchInternalNewData(text);
      }
    },
    500,
    [text]
  );

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };
  const checkBottomInternal = (e: any) => {
    setLoadCondition(false);
    setInternalOffset((prv) => prv + limit);
  };
  const onMenuClose = () => {
    setLoadCondition(true);
    setInternalOffset(0);
  };
  return (
    <Modal
      isOpen={showAddEditHolidayCalenderModal}
      toggle={toggleAddEditHolidayCalenderModal}
    >
      <ModalHeader className="pt-4 pl-4">
        {`${isEdit ? "Edit" : "Add"} Holiday Calendar`}
      </ModalHeader>
      <ModalBody className="pl-4 pr-4">
        <form>
          <div className="col-md-6 p-0">
            <div className="form-group mt-3">
              <label className="mb-1" htmlFor="">
                Date <span className="color-red">*</span>
              </label>

              <div className="date-picker-wraper mr-0">
                <Label className="m-0 p-0 w-100">
                  <ReactDatePicker
                    dateFormat="dd-MM-yyyy"
                    selected={
                      date
                        ? new Date(
                            moment(`${date}T00:00:00`, "YYYY-MM-DD").format(
                              "YYYY-MM-DD[T]HH:mm:ss"
                            )
                          )
                        : null
                    }
                    onChange={(e: any) => {
                      handleDateChange?.(moment(e).format("YYYY-MM-DD"));
                    }}
                    fixedHeight
                    showMonthDropdown
                    showYearDropdown
                    name="dateOfHoliday"
                    placeholderText="Date"
                    className="form-control"
                  />
                  <span
                    className="calender-icon"
                    style={{ right: "30px", cursor: "pointer", top: "35px" }}
                  >
                    <CalenderIcon />
                  </span>
                </Label>
              </div>
            </div>
          </div>
          <div className="col-md-6 p-0">
            <label className="mb-1" htmlFor="">
              Country <span className="color-red">*</span>
            </label>
            <Select
              onMenuClose={onMenuClose}
              value={countryListDropdownSelected}
              isSearchable={true}
              options={finalCountryDropDownList}
              components={{ Option }}
              onChange={(e) => handleChangeCountry(e)}
              onMenuScrollToBottom={(e: any) => checkBottomInternal(e)}
              onInputChange={(e: string) => {
                setLoadCondition(false);
                setText(e);
              }}
              isLoading={countryFetching}
            />
          </div>

          <div className="col-md-6 p-0">
            <label className="mb-1" htmlFor="">
              Branch
            </label>
            <Select
              options={
                finalBranchDataList?.length
                  ? [
                      { value: null, label: "All Branches" },
                      ...finalBranchDataList,
                    ]
                  : finalBranchDataList
              }
              value={branch}
              onChange={(e) => handleBranchDropDownChange(e)}
              isSearchable={true}
              isLoading={branchFetching}
              isMulti={true}
              onMenuClose={onMenuClose}
              onMenuScrollToBottom={(e: any) => checkBottom(e)}
              onInputChange={(e: any) => {
                setLoadCondition(false);
                setBranchText(e);
                setBranchoffset(0);
              }}
            />
          </div>

          <div className="form-group mt-3">
            <div>
              <label htmlFor="description">Title <span className="color-red">*</span></label>
              <input
                className={`form-control`}
                name="text"
                maxLength={20}
                value={description}
                autoFocus
                onChange={(e) => handleDescriptionChange(e)}
              />
            </div>
            <span className="input-length">
              {returnInputFieldLength(description?.length, 20)}
            </span>
          </div>

          <div className="form-group mt-3">
            <div>
              <label htmlFor="sub-description">Sub Description</label>
              <textarea
                className={`form-control`}
                name="subDescription"
                maxLength={200}
                value={subDescription}
                autoFocus
                onChange={(e) => handleSubDescriptionChange(e)}
              />
            </div>
            <span className="input-length">
              {returnInputFieldLength(subDescription?.length, 200)}
            </span>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <span className="pointer" onClick={toggleAddEditHolidayCalenderModal}>
          Cancel
        </span>
        <Button
          color="primary ml-3"
          onClick={() => {
            handleAddHoliday();
            toggleAddEditHolidayCalenderModal();
          }}
          disabled={!date || !countryListDropdownSelected?.label || !description?.trim()?.length}
        >
          {isEdit ? "Update" : "Add"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddEditHolidayCalender;
